import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Invalid query params that create duplicate URLs in Google
const INVALID_PUBLIC_PARAMS = ['city', 'page', 'filter', 'sort'];

// Routes where query params are allowed
const ALLOWED_PARAM_ROUTES = ['/admin', '/owner', '/demo', '/cart', '/dashboard', '/complete-payment', '/payment'];

export const TrailingSlashRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;
    let needsRedirect = false;
    let newPathname = pathname;
    let newSearch = search;

    // 1. Remove trailing slash (except root)
    if (pathname !== '/' && pathname.endsWith('/')) {
      newPathname = pathname.slice(0, -1);
      needsRedirect = true;
    }

    // 2. Remove invalid query params on public pages
    // These params are NOT used by our app routes and create duplicate URLs in Google
    const isAllowedRoute = ALLOWED_PARAM_ROUTES.some(route => pathname.startsWith(route));
    
    if (!isAllowedRoute && search) {
      const params = new URLSearchParams(search);
      let hasInvalidParam = false;
      
      for (const param of INVALID_PUBLIC_PARAMS) {
        if (params.has(param)) {
          hasInvalidParam = true;
          params.delete(param);
        }
      }
      
      if (hasInvalidParam) {
        newSearch = params.toString() ? `?${params.toString()}` : '';
        needsRedirect = true;
      }
    }

    // 3. Perform redirect if needed
    if (needsRedirect) {
      navigate(`${newPathname}${newSearch}${hash}`, { replace: true });
    }
  }, [location, navigate]);

  return null;
};
